import { Pipe, PipeTransform } from '@angular/core';
import { optionsUI } from 'src/app/utils/optionsUI';
import { CurrencyState } from 'src/app/_models/state/optionUIState';

@Pipe({
  name: 'displayCurrency',
})
export class DisplayCurrencyPipe implements PipeTransform {
  transform(value: number, currency: CurrencyState): string {
    return currency?.isPrefix
      ? // eslint-disable-next-line no-undefined
        `${currency?.symbol}${Number(value)?.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`
      : // eslint-disable-next-line no-undefined
        `${value?.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}${currency?.symbol}`;
  }
}
